import React, { useState, useEffect } from "react";

const AddVideo = () => {
  const [dataVideo, setDataVideo] = useState([
    {
      name: "", // name of the date
      youtube_url: "", // youtube url
    },
  ]);
  const [course, setCourse] = useState("");
  const [isPending, setIsPending] = useState(false);
  const [courseNames, setCourseNames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/courses`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setLoading(false);
        const courses = data.msg.map((b, index) => b.courses);
        let arr = [];
        courses.map((course, index) => arr.push(...course));
        let getCourses = arr.map((ele) => {
          return {
            id: ele._id,
            name: ele.name,
          };
        });
        setCourseNames(getCourses);
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsPending(true);

    const post = {
      data: dataVideo,
    };

    fetch(`${process.env.REACT_APP_BASE_URL}/admin/lesson/${course}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(post),
    })
      .then((data) => data.json())
      .then((res) => {
        setIsPending(false);

        if (res.msg === "success") {
          setIsPending(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsPending(false);
      });
  };

  const handleChange = (e, index) => {
    setDataVideo([
      ...dataVideo.map((ele, i) => {
        if (i === index) {
          return {
            ...ele,
            [e.target.name]: e.target.value,
          };
        } else {
          return ele;
        }
      }),
    ]);
  };

  const handleAdd = () => {
    setDataVideo([
      ...dataVideo,
      {
        name: "",
        youtube_url: "",
      },
    ]);
  };

  const handleRemove = (index) => {
    setDataVideo([...dataVideo.filter((ele, i) => i !== index)]);
  };

  return loading ? (
    <div style={{ width: "", textAlign: "center", marginTop: "300px" }}>
      <div className="lds-dual-ring"></div>
    </div>
  ) : (
    <div className="add-video mt-4">
      <div className="container">
        <div className="row">
          <div className="col-md-11 m-auto">
            <div className="mb-3">
              <h3>Add Video</h3>
            </div>
            <form className="form-container" onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Course List</label>
                <select
                  onChange={(e) => {
                    setCourse(e.target.value);
                  }}
                  className="form-select"
                >
                  <option value=""></option>
                  {courseNames.map((n, index) => (
                    <option value={n.id} key={index}>
                      {n.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="add-more mt-3 d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-primary"
                  aria-label="add more"
                  onClick={handleAdd}
                  style={{
                    fontSize: ".8rem",
                  }}
                >
                  Add More {dataVideo.length}
                </button>
              </div>
              {dataVideo.map((_, index) => (
                <div className="form-group mt-3" key={index}>
                  <div className="row align-items-center">
                    <div className="col-md-4">
                      <div
                        className="datails-content-youtube"
                        style={{ width: "100%" }}
                      >
                        <label className="lab-text-dash">name</label>
                        <input
                          type="text"
                          placeholder="enter name"
                          onChange={(e) => handleChange(e, index)}
                          name="name"
                          required
                        />
                      </div>
                    </div>
                    <div className={index === 0 ? "col-md-8" : "col-md-7"}>
                      <div
                        className="datails-content-youtube"
                        style={{ width: "100%" }}
                      >
                        <label className="lab-text-dash">Youtube URL</label>
                        <input
                          type="url"
                          placeholder="youtube url"
                          onChange={(e) => handleChange(e, index)}
                          name="youtube_url"
                          required
                        />
                      </div>
                    </div>
                    {index !== 0 && (
                      <div className="col-md-1">
                        <div className="mt-4">
                          <button
                            type="button"
                            className="btn btn-danger"
                            aria-label="delete"
                            style={{
                              fontSize: ".8rem",
                              padding: "0.4rem .7rem",
                            }}
                            onClick={() => handleRemove(index)}
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}

              <button className="contButSmall">
                {!isPending ? "Save" : "Saving..."}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddVideo;
